import { render, staticRenderFns } from "./UserProfileDeleteProgressDialog.vue?vue&type=template&id=8faf4750&"
import script from "./UserProfileDeleteProgressDialog.vue?vue&type=script&lang=ts&"
export * from "./UserProfileDeleteProgressDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports